/* eslint-disable */
import * as types from '../constants/actionTypes';
import objectAssign from 'object-assign';
import initialState from './initialState';
import * as _ from 'underscore';
import { randId } from '../utils/commonHelper';

// IMPORTANT: Note that with Redux, state should NEVER be changed.
// State is considered immutable. Instead,
// create a copy of the state passed and set new values on the copy.
// Note that I'm using Object.assign to create a copy of current state
// and update values on the copy.
export default function dashboardReducer(state = initialState.dashboard, action) {
  let cols;
  let mass_check;
  let multipage_list;

  switch (action.type) {
    /* auth */
    case types.SET_AUTH_SUCCESS:
      return objectAssign({}, state, { auth: action.auth });

    case types.SET_AUTH_FAILED:
      return objectAssign({}, state, initialState);

    /* get ad listing */
    case types.OPEN_TAB_API_SUCCESS:
      if (typeof state.currentTab !== 'undefined' && state.currentTab != action.adsType) {
        // do not update state so that listing will not be overwritten by newly loaded listing from previous tab
        return state;
      }
      cols = [];
      cols = Object.assign([], action.adData);
      cols.map((col) => {
        col.adSelected = false;
        col.adChecked = {};
      });
      return objectAssign({}, state, {
        adData: cols,
        adTotal: Object.assign({}, state.adTotal, action.adTotal),
        totalPages: action.totalPages,
        adRowLoading: false,
        adMassChecked: false,
      });

    case types.OPEN_LOW_VIS_TAB_API_SUCCESS:
      if (
        typeof state.currentTab !== 'undefined' &&
        typeof action.adsType !== 'undefined' &&
        state.currentTab != action.adsType
      ) {
        // do not update state so that listing will not be overwritten by newly loaded listing from previous tab
        return state;
      }
      cols = [];
      cols = Object.assign([], action.adData);
      cols.map((col) => {
        col.adSelected = false;
        col.adChecked = {};
      });
      action.enabled = action.enabled != false ? true : false;
      return objectAssign({}, state, {
        adData: cols,
        adTotal: Object.assign({}, state.adTotal, action.adTotal),
        totalPages: action.totalPages,
        adRowLoading: false,
        adMassChecked: false,
      });

    case types.OPEN_LOW_VIS_TAB_API_FIRST_LOAD_SUCCESS:
      action.enabled = action.enabled != false ? true : false;
      return objectAssign({}, state, {
        adTotal: Object.assign({}, state.adTotal, action.adTotal),
      });

    case types.OPEN_TAB_API_ERROR:
      if (
        typeof state.currentTab !== 'undefined' &&
        typeof action.adsType !== 'undefined' &&
        state.currentTab != action.adsType
      ) {
        // do not update state so that listing will not be overwritten by newly loaded listing from previous tab
        return state;
      }
      return objectAssign({}, state, { adData: [], adRowLoading: false });

    case types.OPEN_TAB_API_REQUEST:
      return objectAssign({}, state, { adRowLoading: true });

    /* get ad listing premium services */
    case types.AD_SERVICE_API_SUCCESS:
      cols = [];
      state.adData.map((col, key) => {
        let ad_service = objectAssign({}, action.adService);
        let service = ad_service.data.filter((serv) => {
          return serv.id == col.id;
        });
        if (service[0].attributes.hasOwnProperty('attributes')) {
          cols.push(
            objectAssign({}, state.adData[key], {
              adService: service[0].attributes.attributes,
            }),
          );
        } else {
          cols.push(
            objectAssign({}, state.adData[key], {
              adService: service[0].attributes,
            }),
          );
        }
      });
      return objectAssign({}, state, { adData: cols, adRowLoading: false });

    case types.AD_SERVICE_API_ERROR:
      return objectAssign({}, state, { adRowLoading: false });

    case types.AD_SERVICE_API_REQUEST:
      return objectAssign({}, state, { adRowLoading: true });

    case types.AD_STATS_API_SUCCESS:
      cols = [];
      state.adData.map((col, key) => {
        let adStats = action.statData.filter((stat) => {
          return stat.id == col.attributes.list_id;
        });
        if (adStats[0].hasOwnProperty('attributes')) {
          // sort daily adview timeline according to date
          if (adStats[0].attributes.hasOwnProperty('daily_adview_count')) {
            let daily_adview_count = _.sortBy(adStats[0].attributes.daily_adview_count, 'date');
            adStats[0].attributes.daily_adview_count = daily_adview_count;
          }
          cols.push(
            objectAssign({}, state.adData[key], {
              adStats: adStats[0].attributes,
            }),
          );
        }
      });
      return objectAssign({}, state, { adData: cols, adRowLoading: false });

    /* get profile */
    case types.INFO_API_REQUEST:
      return objectAssign({}, state, { infoLoading: true });

    case types.INFO_API_SUCCESS:
      return objectAssign({}, state, {
        profile: action.profile,
        infoLoading: false,
      });

    case types.INFO_API_ERROR:
      return objectAssign({}, state, { infoLoading: false });

    /* get Gamification */
    case types.GAMIFICATION_API_REQUEST:
      return objectAssign({}, state, { gamificationLoading: true });

    case types.GAMIFICATION_API_SUCCESS:
      return objectAssign({}, state, {
        gamification: action.gamification.data,
        gamificationLoading: false,
      });

    case types.GAMIFICATION_API_ERROR:
      return objectAssign({}, state, { gamificationLoading: false });

    /* get credit info */
    case types.CREDIT_API_REQUEST:
      return objectAssign({}, state, { creditLoading: true });

    case types.CREDIT_API_SUCCESS:
      return objectAssign({}, state, {
        credit: action.credit,
        creditLoading: false,
      });

    case types.CREDIT_API_ERROR:
      return objectAssign({}, state, { creditLoading: false });

    case types.PAYMENT_RESULT_REQUEST:
      return objectAssign({}, state, { paymentResultLoading: true });

    case types.PAYMENT_RESULT_SUCCESS:
      return objectAssign({}, state, {
        payment: action.payment.data,
        paymentResultLoading: false,
      });

    case types.PAYMENT_RESULT_ERROR:
      return objectAssign({}, state, {
        errors: action.apiError.response.data.errors,
        paymentResultLoading: false,
      });

    case types.TRANSACTION_API_ERROR:
      return objectAssign({}, state, { transactionLoading: false });

    case types.CREDIT_PLANS_GET_API_SUCCESS:
      return {
        ...state,
        credit_plans: action.data,
      };

    case types.CREDIT_PLANS_PAYMENT_METHOD_GET_SUCCESS:
      return {
        ...state,
        credit_payment_methods: action.data,
      };
    case types.GALLERY_GET_API_REQUEST:
      return {
        ...state,
        galleryLoading: true,
      };
    case types.GALLERY_GET_API_SUCCESS:
      return {
        ...state,
        galleryLoading: false,
        gallery: {
          ...state.gallery,
          images: action.images,
        },
        galleryTotalPages: action.meta?.pages,
      };
    case types.GALLERY_GET_API_ERROR:
      return {
        ...state,
        galleryLoading: false,
        gallery: {
          ...state.gallery,
          images: [],
        },
        galleryTotalPages: 0,
      };

    case types.GALLERY_POST_API_REQUEST:
      return {
        ...state,
        gallery: {
          ...state.gallery,
          uploading: true,
          upload_response: action.uploadResponses,
        },
      };
    case types.GALLERY_POST_API_COMPLETED:
      return {
        ...state,
        gallery: {
          ...state.gallery,
          uploading: false,
        },
      };
    case types.GALLERY_POST_API_SUCCESS:
      return {
        ...state,
        gallery: {
          ...state.gallery,
          upload_response: {
            ...state.gallery.upload_response,
            [action.id]: {
              ...state.gallery.upload_response[action.id],
              status: 'success',
              errors: [],
            },
          },
        },
      };
    case types.GALLERY_POST_API_ERROR:
      let errors = action.apiError.response.data.errors
        ? action.apiError.response.data.errors
        : [
            {
              title: 'MISCELLANEOUS_ERROR',
              detail:
                'Something went wrong, please try again later. If it still fails, please report <a href={`${process.env.SITE_2_URL}/support/form/0?ca=9_s&id=1`} target="_blank">here</a>',
            },
          ];

      return {
        ...state,
        gallery: {
          ...state.gallery,
          upload_response: {
            ...state.gallery.upload_response,
            [action.id]: {
              ...state.gallery.upload_response[action.id],
              status: 'error',
              errors,
            },
          },
        },
      };
    case types.GALLERY_POST_API_PROGRESS:
      return {
        ...state,
        gallery: {
          ...state.gallery,
          upload_response: {
            ...state.gallery.upload_response,
            [action.id]: {
              ...state.gallery.upload_response[action.id],
              fileSize: action.bytes,
              percentage: action.percentage,
            },
          },
        },
      };

    /* buy premium services, multi prolong and delete ad */
    case types.BATCH_API_REQUEST:
      const batchPostingRequest = {
        total: action.total,
        current: 0,
      };
      return objectAssign({}, state, {
        batchPosting: batchPostingRequest,
      });

    case types.BATCH_API_NEXT:
      const batchPostingNext = Object.assign({}, state.batchPosting, {
        current: action.current,
      });
      return objectAssign({}, state, { batchPosting: batchPostingNext });

    case types.BATCH_API_SUCCESS:
      const batchPostingSuccess = {
        total: 0,
        current: 0,
      };
      return objectAssign({}, state, {
        batchPosting: batchPostingSuccess,
      });

    /* change car store type */
    case types.CHANGE_PLAN_API_REQUEST:
      return objectAssign({}, state, { infoLoading: true });

    case types.CHANGE_PLAN_API_SUCCESS:
      return objectAssign({}, state, { infoLoading: false });

    case types.CHANGE_PLAN_API_ERROR:
      return objectAssign({}, state, { infoLoading: false });

    /* update checkbox (left column) */
    case types.UPDATE_SELECTED:
      // update to multiPageList instead of adData
      multipage_list = Object.assign([], state.multiPageList);
      // check adData for current listing
      state.adData.map((col, key) => {
        // find which ad selected (only 1 ad will be found) OR mass selected (all ads), exclude deleted ad
        if ((col.id == action.id || action.mass) && !col.attributes.db_del) {
          // check if the ad checked and stored in multiPageList before
          const existing = multipage_list.findIndex((ad) => {
            return ad.id == col.id;
          });
          if (
            (existing >= 0 && col.adService.republish_action.enabled && col.adService.bulk_action.select_enabled) ||
            (existing >= 0 &&
              !col.adService.republish_action.enabled &&
              col.adService.bulk_action.select_enabled &&
              action.tab == 'published')
          ) {
            multipage_list[existing] = Object.assign({}, multipage_list[existing], { adSelected: action.val });
          } else if (
            (existing < 0 && col.adService.republish_action.enabled && col.adService.bulk_action.select_enabled) ||
            (existing < 0 &&
              !col.adService.republish_action.enabled &&
              col.adService.bulk_action.select_enabled &&
              action.tab == 'published')
          ) {
            multipage_list.push(Object.assign({}, col, { adSelected: action.val }));
          }
        }
      });

      // for adMassChecked
      if (action.mass || action.val == false) {
        mass_check = action.val;
      } else {
        mass_check = state.adMassChecked;
      }
      return objectAssign({}, state, {
        adMassChecked: mass_check,
        multiPageList: multipage_list,
      });

    /* update checkbox (right column) */
    case types.UPDATE_PREMIUM_CHECKED:
      // update to multiPageList instead of adData
      multipage_list = Object.assign([], state.multiPageList);
      // check adData for current listing
      state.adData.map((col, key) => {
        // find which ad checked (only 1 ad will be found) OR mass checked (all ads)
        if (col.id == action.id || action.mass) {
          // check if the ad checked and stored in multiPageList before
          let ad_checked = {};
          const existing = multipage_list.findIndex((ad) => {
            return ad.id == col.id;
          });

          if (existing >= 0) {
            ad_checked = objectAssign({}, multipage_list[existing].adChecked);
            ad_checked[action.service] = action.val;
            multipage_list[existing] = Object.assign({}, multipage_list[existing], { adChecked: ad_checked });
          } else {
            ad_checked[action.service] = action.val;
            multipage_list.push(Object.assign({}, col, { adChecked: ad_checked }));
          }
        }
      });
      return objectAssign({}, state, { multiPageList: multipage_list });

    /* update by key value. For general use. */
    case types.UPDATE_KEY_VALUE:
      return objectAssign({}, state, { [action.key]: action.value });

    case types.SET_ADROW_LOADING: {
      return {
        ...state,
        adRowLoading: action.adRowLoading,
      };
    }
    case types.STOREUSERS_API_REQUEST:
      return {
        ...state,
        storeUsersLoading: true,
      };
    case types.STOREUSERS_API_COMPLETE:
      let res = {
        ...state,
        storeUsersLoading: false,
      };

      let newMessages = {};
      if (action.messageToRemove) {
        delete newMessages[action.messageToRemove];
      } else if (action.message) {
        const id = randId();
        newMessages[id] = action.message;
      }

      res = {
        ...res,
        store_users: {
          ...res.store_users,
          messages: newMessages,
        },
      };

      return res;

    case types.STOREUSERS_GET_API_SUCCESS:
      return {
        ...state,
        storeUsersLoading: false,
        store_users: {
          ...state.store_users,
          users: action.store_users.data,
          meta: action.store_users.meta,
        },
      };
    case types.STOREUSERS_SELECT_USER:
      return {
        ...state,
        store_users: {
          ...state.store_users,
          editing: action.user,
        },
      };
      break;
    case types.STOREUSERS_UPDATE_API_SUCCESS:
      return {
        ...state,
        storeUsersLoading: false,
        store_users: {
          ...state.store_users,
          users: {
            ...state.store_users.users,
            [action.id]: {
              ...state.store_users.users[action.id],
              ...action.updates,
            },
          },
        },
      };
    case types.PURCHASE_CREDITS_SUCCESS:
      return {
        ...state,
        credits_purchased_success: true,
        credits_purchased_error: null,
      };
    case types.PURCHASE_CREDITS_SUCCESS:
      return {
        ...state,
        credits_purchased_success: true,
        credits_purchased_error: action.error,
      };

    case types.GET_CREDIT_BALANCE_REQUEST:
      return {
        ...state,
        creditV2: {
          loading: true,
        },
      };
    case types.GET_CREDIT_BALANCE_SUCCESS:
      const creditV2 = action.creditBalance;

      // Prepare additional info for promo credits
      let expiringPromoCreditAmount = 0,
        expiringInDays = 0,
        expiringPromoCreditLabel = '';

      // Cater for edge cases when either transferable or non-transferable amount is zero
      if (creditV2?.promo?.transferable?.amount === 0 && creditV2?.promo?.non_transferable?.amount > 0) {
        // If transferable amount is 0 non-transferable has an amount
        expiringPromoCreditAmount = creditV2?.promo?.non_transferable?.expiry?.amount;
        expiringInDays = creditV2?.promo?.non_transferable?.expiry?.day;
        expiringPromoCreditLabel =
          expiringPromoCreditAmount === creditV2?.promo?.total
            ? expiringInDays === 0
              ? 'Expiring today'
              : `Expiring in ${creditV2?.promo?.non_transferable?.expiry?.day} ${
                  creditV2?.promo?.non_transferable?.expiry?.day === 1 ? 'day' : 'days'
                }`
            : expiringInDays === 0
            ? `${expiringPromoCreditAmount} expiring today`
            : `${expiringPromoCreditAmount} expiring in ${creditV2?.promo?.non_transferable?.expiry?.day} ${
                creditV2?.promo?.non_transferable?.expiry?.day === 1 ? 'day' : 'days'
              }`;
      } else if (creditV2?.promo?.non_transferable?.amount === 0 && creditV2?.promo?.transferable?.amount > 0) {
        // If non-transferable amount is 0 transferable has an amount
        expiringPromoCreditAmount = creditV2?.promo?.transferable?.expiry?.amount;
        expiringInDays = creditV2?.promo?.transferable?.expiry?.day;
        expiringPromoCreditLabel =
          expiringPromoCreditAmount === creditV2?.promo?.total
            ? expiringInDays === 0
              ? 'Expiring today'
              : `Expiring in ${creditV2?.promo?.transferable?.expiry?.day} ${
                  creditV2?.promo?.transferable?.expiry?.day === 1 ? 'day' : 'days'
                }`
            : expiringInDays === 0
            ? `${expiringPromoCreditAmount} expiring today`
            : `${expiringPromoCreditAmount} expiring in ${creditV2?.promo?.transferable?.expiry?.day} ${
                creditV2?.promo?.transferable?.expiry?.day === 1 ? 'day' : 'days'
              }`;

        // When both transferable and non-transferable amounts have value
      } else {
        if (creditV2?.promo?.transferable?.expiry?.day === creditV2?.promo?.non_transferable?.expiry?.day) {
          // If both transferable and non-transferable promo credits expire on the same day
          // sum up both expiring credits
          expiringPromoCreditAmount =
            creditV2?.promo?.transferable?.expiry?.amount + creditV2?.promo?.non_transferable?.expiry?.amount;
          expiringInDays = creditV2?.promo?.transferable?.expiry?.day;
          expiringPromoCreditLabel =
            creditV2?.promo?.transferable?.expiry?.day === 0
              ? 'Expiring today'
              : `Expiring in ${creditV2?.promo?.transferable?.expiry?.day} ${
                  creditV2?.promo?.transferable?.expiry?.day === 1 ? 'day' : 'days'
                }`;
        } else if (creditV2?.promo?.transferable?.expiry?.day < creditV2?.promo?.non_transferable?.expiry?.day) {
          // If transferable promo credits expire sooner than non-transferable
          // use transferable amount and days
          expiringPromoCreditAmount = creditV2?.promo?.transferable?.expiry?.amount;
          expiringInDays = creditV2?.promo?.transferable?.expiry?.day;
          expiringPromoCreditLabel =
            expiringInDays === 0
              ? `<b>${expiringPromoCreditAmount}</b> expiring today`
              : `<b>${expiringPromoCreditAmount}</b> expiring in ${creditV2?.promo?.transferable?.expiry?.day} ${
                  creditV2?.promo?.transferable?.expiry?.day === 1 ? 'day' : 'days'
                }`;
        } else {
          // If non-transferable promo credits expire sooner than transferable
          // use non-transferable amount and days
          expiringPromoCreditAmount = creditV2?.promo?.non_transferable?.expiry?.amount;
          expiringInDays = creditV2?.promo?.non_transferable?.expiry?.day;
          expiringPromoCreditLabel =
            expiringInDays === 0
              ? `<b>${expiringPromoCreditAmount}</b> expiring today`
              : `<b>${expiringPromoCreditAmount}</b> expiring in ${creditV2?.promo?.non_transferable?.expiry?.day} ${
                  creditV2?.promo?.non_transferable?.expiry?.day === 1 ? 'day' : 'days'
                }`;
        }
      }

      const expiryDateTransferable = new Date(creditV2?.promo?.transferable?.expiry?.date).toLocaleString('en-MY', {
        year: 'numeric',
        month: 'long',
        day: 'numeric',
      });

      const expiryDateNonTransferable = new Date(creditV2?.promo?.non_transferable?.expiry?.date).toLocaleString(
        'en-MY',
        {
          year: 'numeric',
          month: 'long',
          day: 'numeric',
        },
      );

      // Prepare additional labels for Transferable and Non-Transferable promo credits
      let expiringTransferableCreditLabel = '',
        expiringNonTransferableCreditLabel = '';

      // If there are transferable promo credits expiring
      if (creditV2?.promo?.transferable?.expiry?.day) {
        if (creditV2?.promo?.transferable?.amount === creditV2?.promo?.transferable?.expiry?.amount) {
          // If all transferable promo credits are expiring, show "Expiring in xxx days"
          expiringTransferableCreditLabel = `Expiring in ${creditV2?.promo?.transferable?.expiry?.day} ${
            creditV2?.promo?.transferable?.expiry?.day === 1 ? 'day' : 'days'
          }`;
        } else {
          // If only partial transferable promo credits are expiring, show "<b>xxx</b> expiring in xxx days"
          expiringTransferableCreditLabel = `<b>${creditV2?.promo?.transferable?.expiry?.amount}</b> expiring in ${
            creditV2?.promo?.transferable?.expiry?.day
          } ${creditV2?.promo?.transferable?.expiry?.day === 1 ? 'day' : 'days'}`;
        }
      } else if (creditV2?.promo?.transferable?.expiry?.day === 0) {
        // If there are transferable promo credits expiring today
        if (creditV2?.promo?.transferable?.amount === creditV2?.promo?.transferable?.expiry?.amount) {
          // If all transferable promo credits are expiring today, show "Expiring today"
          expiringTransferableCreditLabel = 'Expiring today';
        } else {
          // If only partial transferable promo credits are expiring today, show "<b>xxx</b> expiring today"
          expiringTransferableCreditLabel = `<b>${creditV2?.promo?.transferable?.expiry?.amount}</b> expiring today`;
        }
      }

      // If there are non-transferable promo credits expiring
      if (creditV2?.promo?.non_transferable?.expiry?.day) {
        if (creditV2?.promo?.non_transferable?.amount === creditV2?.promo?.non_transferable?.expiry?.amount) {
          // If all non-transferable promo credits are expiring, show "Expiring in xxx days"
          expiringNonTransferableCreditLabel = `Expiring in ${creditV2?.promo?.non_transferable?.expiry?.day} ${
            creditV2?.promo?.non_transferable?.expiry?.day === 1 ? 'day' : 'days'
          }`;
        } else {
          // If only partial non-transferable promo credits are expiring, show "<b>xxx</b> expiring in xxx days"
          expiringNonTransferableCreditLabel = `<b>${
            creditV2?.promo?.non_transferable?.expiry?.amount
          }</b> expiring in ${creditV2?.promo?.non_transferable?.expiry?.day} ${
            creditV2?.promo?.non_transferable?.expiry?.day === 1 ? 'day' : 'days'
          }`;
        }
      } else if (creditV2?.promo?.non_transferable?.expiry?.day === 0) {
        // If there are non-transferable promo credits expiring today
        if (creditV2?.promo?.non_transferable?.amount === creditV2?.promo?.non_transferable?.expiry?.amount) {
          // If all non-transferable promo credits are expiring today, show "Expiring today"
          expiringNonTransferableCreditLabel = 'Expiring today';
        } else {
          // If only partial non-transferable promo credits are expiring today, show "<b>xxx</b> expiring today"
          expiringNonTransferableCreditLabel = `<b>${creditV2?.promo?.non_transferable?.expiry?.amount}</b> expiring today`;
        }
      }

      // Prepare additional labels for Normal credits
      let normalCreditsExpiryLabel = '',
        normalCreditsTopUpLabel = '',
        alert = false,
        burning = false;

      if (creditV2?.normal?.amount === 0) {
        // If no normal credits available
        normalCreditsExpiryLabel = 'You currently have no credits';
        normalCreditsTopUpLabel = 'Top up your credits and start posting';
        alert = true;
      } else if (creditV2?.normal?.expiry?.day === 0 && creditV2?.normal?.grace?.day > 0) {
        // If normal credits have expired but still in grace period
        normalCreditsExpiryLabel = `${creditV2?.normal?.grace?.day} ${
          creditV2?.normal?.grace?.day === 1 ? 'day' : 'days'
        } left to credits burn`;
        normalCreditsTopUpLabel = 'Top up now to use the credits and extend validity';
        alert = true;
        burning = true;
      } else if (creditV2?.normal?.expiry?.day <= 7) {
        // If normal credits are expiring in 7 days or less
        normalCreditsExpiryLabel = `Expiring in ${creditV2?.normal?.expiry?.day} ${
          creditV2?.normal?.expiry?.day === 1 ? 'day' : 'days'
        }`;
        normalCreditsTopUpLabel = 'Top up now to extend credits validity';
        alert = true;
      } else {
        normalCreditsExpiryLabel = `Expiring in ${creditV2?.normal?.expiry?.day} days`;
      }

      // If there are promo credits, show "Normal Credits" in Credit Box title
      // Otherwise, show "Credit Balance" Credit Box title
      const normalCreditsTitle = creditV2?.promo?.total > 0 ? 'Normal Credits' : 'Credit Balance';

      return {
        ...state,
        creditV2: {
          loading: false,
          expiringPromoCredits: {
            day: expiringInDays,
            amount: expiringPromoCreditAmount,
            label: expiringPromoCreditLabel,
            alert: expiringInDays <= 7 || false,
            transferable: {
              label: expiringTransferableCreditLabel,
              alert: creditV2?.promo?.transferable?.expiry?.day <= 7 || false,
              date: expiryDateTransferable,
            },
            nonTransferable: {
              label: expiringNonTransferableCreditLabel,
              alert: creditV2?.promo?.non_transferable?.expiry?.day <= 7 || false,
              date: expiryDateNonTransferable,
            },
          },
          normalCreditsLabels: {
            title: normalCreditsTitle,
            expiryLabel: normalCreditsExpiryLabel,
            topUpLabel: normalCreditsTopUpLabel,
            alert: alert,
            burning: burning,
          },
          ...creditV2,
        },
      };
    case types.GET_CREDIT_BALANCE_ERROR:
      return {
        ...state,
        creditV2: {
          loading: false,
        },
      };
    case types.GET_PROFILE_FROM_HEADER: {
      const attrs = action.profile?.data?.attributes || {};

      return {
        ...state,
        profile: {
          store_id: attrs.store_id,
          name: attrs.name,
          email: attrs.email,
          category: attrs.category,
          parent_category: attrs.parent_category,
          category_name: attrs.category_name,
          type: attrs.type,
          role: attrs.role,
          livechat: attrs.livechat == 1 ? true : false,
          company: attrs.company_name,
          user_phone: attrs.phone,
          user_id: attrs.user_id,
          store_group: attrs.store_group || {},
          store_network: attrs.store_network || {},
          auto_top_up: attrs.auto_top_up || {},
          verified_allowed: attrs.verified_allowed,
          verified_label: attrs.verified_label,
          eInvoice: { enabled: true },
        },
      };
    }
    default:
      return state;
  }
}
